import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

import { prepareDefaultHeaders } from '../../api'

// Every migrated CSM tool reads and writes the account server's admin API.
export const internalAccountApi = createApi({
  reducerPath: 'internalAccountApi',
  baseQuery: fetchBaseQuery({
    baseUrl: window.GR_API_URLS.API_URL_ACCOUNT + '/admin/',
    prepareHeaders: prepareDefaultHeaders,
  }),
  endpoints: () => ({}),
})
